import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../../services/api';
import type { ReviseContractRequest } from './use-revise-contract-types/revise-contract-request';

export function useReviseContract(options?: UseMutationOptions<void, unknown, ReviseContractRequest>) {
  return useMutation({
    mutationFn: async (requestParameters) => {
      const api = getPrivateApi();
      await api.reviseContract(requestParameters);
    },
    ...options,
  });
}
